export const getLogTypeOptions = () => {
    let opt = [];
    for (let key in LOG_TYPES) {
        opt.push({label: key, value: key});
    }
    return opt;
}

const LOG_TYPES = {
    // Products
    product_create: "When a product is created",
    product_update: "When a product is updated",
    product_delete: "When a product is deleted",

    // Product Movements
    productMovement_create: "When a product movement is created",
    productMovement_update: "When a product movement is updated",
    productMovement_delete: "When a product movement is deleted",

    // Product Prices
    productPrice_create: "When a product price is created",
    productPrice_update: "When a product price is updated",
    productPrice_delete: "When a product price is deleted",

    // Product Categories
    productCategory_create: "When a product category is created",
    productCategory_update: "When a product category is updated",
    productCategory_delete: "When a product category is deleted",

    // Product Subcategories
    productSubcategory_create: "When a product subcategory is created",
    productSubcategory_update: "When a product subcategory is updated",
    productSubcategory_delete: "When a product subcategory is deleted",

    // Sales
    sale_create: "When a sale is created",
    sale_update: "When a sale is updated", // Only for imports
    sale_delete: "When a sale is deleted",
    sale_sendMyData: "When a sale is sent to my data",
    sale_sendMyDataProvider: "When a sale is sent to my data provider",

    // SalesGeneralSettings
    salesSetting_update: "When sale settings are updated",

    // QuickRetailSettings
    quickRetailSalesSetting_update: "When quick retail sale settings are updated",

    // Buys
    buy_create: "When a buy is created",
    buy_update: "When a buy is updated",
    buy_delete: "When a buy is deleted",
    buy_sendMyData: "When a buy is sent to my data",

    // BuyGeneralSettings
    buysSetting_update: "When buy settings are updated",

    // Clients
    client_create: "When a client is created",
    client_update: "When a client is updated",
    client_delete: "When a client is deleted",

    // Client Settings
    clientSetting_create: "When client settings are created",
    clientSetting_update: "When client settings are updated",

    // Client Payments
    clientPayment_create: "When a client payment is created",
    clientPayment_update: "When a client payment is updated",
    clientPayment_delete: "When a client payment is deleted",

    // Client Movements
    clientMovement_create: "When a client movement is created",
    clientMovement_update: "When a client movement is updated",
    clientMovement_delete: "When a client payment is deleted",

    // Suppliers
    supplier_create: "When a supplier is created",
    supplier_update: "When a supplier is updated",
    supplier_delete: "When a supplier is deleted",

    // Supplier Settings
    supplierSetting_create: "When supplier settings are created",
    supplierSetting_update: "When supplier settings are updated",

    // Supplier Payments
    supplierPayment_create: "When a supplier payment is created",
    supplierPayment_update: "When a supplier payment is updated",
    supplierPayment_delete: "When a supplier payment is deleted",

    // Supplier Movements
    supplierMovement_create: "When a supplier movement is created",
    supplierMovement_update: "When a supplier movement is updated",
    supplierMovement_delete: "When a supplier payment is deleted",

    // Employees
    employee_create: "When an employee is created",
    employee_update: "When an employee is updated",
    employee_delete: "When an employee is deleted",

    // Work Permit
    workPermit_create: "When a work permit is created",
    workPermit_update: "When a work permit is updated",
    workPermit_delete: "When a work permit is deleted",

    // Work Movements
    workMovement_create: "When a work movement is created",
    workMovement_update: "When a work movement is updated",
    workMovement_delete: "When a work movement is deleted",

    // Cash
    cash_create: "When cash is created",
    cash_update: "When cash is updated",
    cash_delete: "When cash is deleted",

    // Cash Settings
    cashSetting_create: "When cash settings are created",
    cashSetting_update: "When cash settings are updated",

    // Bank Register
    bank_create: "When bank is created",
    bank_update: "When bank is updated",
    bank_delete: "When bank is deleted",
    bank_sync: "When bank account transactions are updated through emails",

    // Pos
    pos_create: "When a pos is created",
    pos_update: "When a pos is updated",
    pos_delete: "When a pos is deleted",

    // Accounting
    account_create: "When an accounting account is created",
    account_update: "When an accounting account is updated",
    account_delete: "When an accounting account is deleted",
    record_create: "When an accounting record is created",
    record_update: "When an accounting record is updated",
    record_delete: "When an accounting record is deleted",

    // Accounting Settings
    accountingSetting_create: "When accounting settings are created",
    accountingSetting_update: "When accounting settings are updated",

    // Payroll Settings
    payrollSetting_create: "When a basic setting is created",
    payrollSetting_update: "When a basic setting is updated",

    // Settings
    basicSetting_create: "When a basic setting is created",
    basicSetting_update: "When a basic setting is updated",
    basicSetting_delete: "When a basic setting is deleted",
    advancedSetting_create: "When an advanced setting is created",
    advancedSetting_update: "When an advanced setting is updated",
    advancedSetting_delete: "When an advanced setting is deleted",

    // File Export
    file_export: "When data is exported",

    // DCL
    dcl_create: "When DCL is created",
    dcl_update: "When DCL is updated",
    cancel_dcl: "When DCL is cancelled",

    // Fixed Assets
    fixed_asset_settings: "When fixed asset settings get changed",

    fixed_asset_create: "When a fixed asset is created",
    fixed_asset_update: "When a fixed asset is updated",
    fixed_asset_delete: "When a fixed asset is deleted",

    fixed_asset_movement_create: "When a fixed asset movement is created",
    fixed_asset_movement_update: "When a fixed asset movement is updated",
    fixed_asset_movement_delete: "When a fixed asset movement is deleted",

    fixed_asset_record_create: "When a fixed asset record is created",
    fixed_asset_record_update: "When a fixed asset record is updated",
    fixed_asset_record_delete: "When a fixed asset record is deleted",

    cheque_create: "When a cheque is created",
    cheque_update: "When a cheque is updated",
    cheque_delete: "When a cheque is deleted",

    loan_create: "When a loan is created",
    loan_update: "When a loan is updated",
    loan_delete: "When a loan is deleted",

    card_create: "When a card is created",
    card_update: "When a card is updated",
    card_delete: "When a card is deleted",

    cancel_document: "When a document is cancelled",

    ai_register: "When a document is registered through AI",
    ai_reprocess: "When a document is sent for reprocessing through AI",
    ai_decline: "When a document is cancelled through AI",

    banking_categories_create: "When a banking category is created",
    banking_categories_update: "When a banking category is updated",
    banking_categories_delete: "When a banking category is deleted",

    banking_sub_categories_create: "When a banking sub category is created",
    banking_sub_categories_update: "When a banking sub category is updated",
    banking_sub_categories_delete: "When a banking sub category is deleted",
}
